module.exports = __webpack_public_path__ + "static/media/settings-icon.0094183c.svg";